import * as ACTIONS from 'constants/Actions'

export const sendContactFormData = (data) => ({
    type: ACTIONS.SEND_CONTACT_INFO,
    data
});